import React, { Component } from "react";

const IconButton = ({
  text,
  onClick,
  icon,
  backgroundColor,
  borderColor,
  fontColor,
  disabled = false,
  disabledColor = "#dddddd",
}) => {
  return (
    <a
      href={onClick}
      target="_blank"
      className={disabled ? "button disableLinkBtn" : "button"}
      style={{
        backgroundColor: backgroundColor,
        color: `${disabled ? disabledColor : fontColor}`,
        border: `1px solid ${disabled ? disabledColor : borderColor}`,
      }}
    >
      <img
        src={icon}
        style={{
          marginTop: "-50px",
          paddingLeft: "100px",
          float: "right",
          textAlign: "right",
        }}
      ></img>
      {text}
    </a>
  );
};

export default IconButton;
